import React, { useEffect, useMemo, useState } from 'react';
import SignIn from '../../pages/ExtraPages/SignIn';
import { useIdleTimer } from 'react-idle-timer';
import { useHistory, useLocation, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  setEmailRedux,
  setLoginAgencyID,
  setPasswordRedux,
  setUserAppNotifications,
  setUserDetailsObj,
  setUserRolePermissionsArr,
  setUserToken
} from '../../Redux/UserSlice';
import {
  AppBar,
  Badge,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  TextField,
  Toolbar,
  Typography,
  useMediaQuery
} from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { setRateValues } from '../../Redux/GetRatesSlice';
import {
  setQuickQuoteRateValues,
  setQuickQuoteTLRateValues
} from '../../Redux/QuickQuoteRateSlice';
import {
  setQuickQuoteDeliveryCheckedRedux,
  setQuickQuotePickUpCheckedRedux
} from '../../Redux/QuickQuoteSwevicesSlice';
import {
  setClassWeight,
  setDimensionsWeight
} from '../../Redux/QuickQuoteTotalWeightSlice';
import { GetAppNotifications, AagencyLogout } from '../../apis/Agency';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import { base_logo_url } from '../../apis/constants';
import { formatNotificationTime, sanitizeHTML } from '../../apis/Utils';
import NotificationCard from '../../pages/Notifications/NotificationCard';
import NotificationDialog from '../../pages/Notifications/NotificationDialog';

// MUI Icons
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import LockPersonIcon from '@mui/icons-material/LockPerson';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import WysiwygIcon from '@mui/icons-material/Wysiwyg';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import SettingsIcon from '@mui/icons-material/Settings';
import NotificationsIcon from '@mui/icons-material/Notifications';
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import CloseIcon from '@mui/icons-material/Close';
import { RequestQuoteRounded } from '@mui/icons-material';
import TrackShipmentModule from '../../pages/TrackShipment/TrackShipmentModule';

// ─── Layout constants ─────────────────────────────────────────────────────────
const DRAWER_WIDTH = 180;
const COLLAPSED_WIDTH = 92;

// ─── Full logo: chevron icon + "ShipTechPro" wordmark ────────────────────────
const AppLogo = () => (
  <svg
    width='160'
    height='25'
    class='my-1'
    viewBox='0 0 356 73'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M19.7868 0.000359717L13.4229 6.36432L28.3075 21.2489C32.6032 25.5447 39.568 25.5447 43.8638 21.2489L58.7488 6.36398L52.3848 1.52588e-05L37.4998 14.885C36.7188 15.666 35.4525 15.666 34.6714 14.885L19.7868 0.000359717Z'
      fill='#3361FF'
    ></path>
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M72.1715 19.7867L65.8076 13.4227L50.923 28.3073C46.6272 32.6031 46.6272 39.5679 50.923 43.8637L65.8079 58.7486L72.1719 52.3847L57.2869 37.4997C56.5059 36.7187 56.5059 35.4524 57.2869 34.6713L72.1715 19.7867Z'
      fill='#3361FF'
    ></path>
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M19.7868 72.1713L13.4229 65.8073L28.3075 50.9227C32.6032 46.627 39.568 46.627 43.8638 50.9227L58.7487 65.8077L52.3848 72.1716L37.4998 57.2867C36.7188 56.5056 35.4525 56.5057 34.6714 57.2867L19.7868 72.1713Z'
      fill='#3361FF'
    ></path>
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M0.000342659 19.7867L6.3643 13.4227L21.2489 28.3074C25.5447 32.6031 25.5447 39.5679 21.2489 43.8637L6.36396 58.7486L-1.70308e-06 52.3847L14.8849 37.4997C15.666 36.7187 15.666 35.4524 14.8849 34.6713L0.000342659 19.7867Z'
      fill='#3361FF'
    ></path>
    <path
      d='M94.7104 42.8213C95.7934 43.1905 96.9749 43.4859 98.2548 43.7074C99.5593 43.9043 100.852 44.0028 102.131 44.0028C103.879 44.0028 105.171 43.929 106.008 43.7813C106.87 43.609 107.436 43.3505 107.706 43.0059C107.977 42.6614 108.113 42.2183 108.113 41.6768C108.113 41.2092 108.014 40.84 107.817 40.5692C107.62 40.2985 107.239 40.0892 106.673 39.9416C106.107 39.7693 105.27 39.6339 104.162 39.5354L101.725 39.3139C99.9039 39.1416 98.464 38.7601 97.4056 38.1694C96.3718 37.5787 95.6334 36.791 95.1904 35.8065C94.772 34.7973 94.5628 33.5913 94.5628 32.1883C94.5628 30.5146 94.895 29.1608 95.5596 28.127C96.2488 27.0933 97.3564 26.3426 98.8824 25.8749C100.408 25.3826 102.439 25.1365 104.974 25.1365C108.273 25.1365 110.992 25.5672 113.134 26.4287L113.023 31.4499L112.912 31.5976C110.475 30.7361 107.928 30.3053 105.27 30.3053C103.99 30.3053 103.005 30.3792 102.316 30.5269C101.627 30.6499 101.147 30.8592 100.876 31.1545C100.605 31.4499 100.47 31.8683 100.47 32.4098C100.47 32.9513 100.556 33.3574 100.728 33.6282C100.925 33.8989 101.307 34.1081 101.873 34.2558C102.439 34.3789 103.264 34.502 104.347 34.625L106.673 34.8835C108.642 35.105 110.155 35.4988 111.214 36.0649C112.272 36.631 112.998 37.3941 113.392 38.354C113.811 39.2893 114.02 40.4338 114.02 41.7876C114.02 43.4367 113.663 44.815 112.949 45.9227C112.26 47.0057 111.128 47.8179 109.552 48.3594C107.977 48.9009 105.873 49.1716 103.239 49.1716C101.516 49.1716 99.9654 49.0855 98.5871 48.9132C97.2087 48.7163 95.8673 48.4579 94.5628 48.1379V42.9321L94.7104 42.8213ZM123.635 48.8394H117.727V25.4688H123.635V34.4035H132.496V25.4688H138.403V48.8394H132.496V39.2032H123.635V48.8394ZM148.729 48.8394H142.822V25.4688H148.729V48.8394ZM159.077 48.8394H153.169V25.4688H163.581C165.919 25.4688 167.79 25.7518 169.193 26.3179C170.596 26.8841 171.605 27.8071 172.22 29.087C172.836 30.3669 173.143 32.1021 173.143 34.2927C173.143 36.3603 172.836 38.0463 172.22 39.3508C171.605 40.6307 170.596 41.5784 169.193 42.1937C167.79 42.809 165.919 43.1167 163.581 43.1167H159.077V48.8394ZM162.621 30.3053H159.077V38.2801H162.621C164.369 38.2801 165.538 37.9848 166.129 37.3941C166.719 36.8033 167.015 35.7696 167.015 34.2927C167.015 32.8898 166.719 31.8806 166.129 31.2653C165.538 30.6253 164.369 30.3053 162.621 30.3053ZM192.149 48.8394V30.453H185.504V25.4688H204.702V30.453H198.057V48.8394H192.149ZM207.288 48.8394V25.4688H224.641V30.2684H213.195V34.6989H223.127V39.4985H213.195V44.0397H224.641V48.8394H207.288ZM245.013 43.7813V48.4332C243.832 48.6794 242.675 48.864 241.543 48.987C240.411 49.1101 239.069 49.1716 237.519 49.1716C235.525 49.1716 233.839 48.9994 232.461 48.6548C231.107 48.3102 230.011 47.7071 229.175 46.8457C228.362 45.9596 227.772 44.7166 227.402 43.1167C227.033 41.5168 226.849 39.4616 226.849 36.951C226.849 34.5389 227.033 32.5575 227.402 31.0068C227.772 29.4562 228.362 28.2624 229.175 27.4256C230.011 26.5641 231.107 25.9734 232.461 25.6534C233.839 25.3088 235.525 25.1365 237.519 25.1365C239.069 25.1365 240.411 25.198 241.543 25.3211C242.675 25.4196 243.832 25.6042 245.013 25.8749V30.6745L244.903 30.7484C243.869 30.5023 242.872 30.33 241.912 30.2315C240.952 30.1084 239.771 30.0469 238.368 30.0469C237.236 30.0469 236.3 30.1331 235.562 30.3053C234.848 30.453 234.282 30.7607 233.864 31.2284C233.445 31.696 233.15 32.3852 232.977 33.2959C232.83 34.2066 232.756 35.425 232.756 36.951C232.756 38.5509 232.83 39.8431 232.977 40.8276C233.15 41.7876 233.445 42.5137 233.864 43.0059C234.282 43.4982 234.848 43.8305 235.562 44.0028C236.3 44.1751 237.236 44.2612 238.368 44.2612C239.746 44.2612 240.915 44.2243 241.875 44.1505C242.86 44.052 243.844 43.8797 244.829 43.6336L245.013 43.7813ZM254.046 48.8394H248.138V25.4688H254.046V34.4035H262.907V25.4688H268.814V48.8394H262.907V39.2032H254.046V48.8394ZM290.209 48.8394H284.302V25.4688H294.713C297.051 25.4688 298.922 25.7518 300.325 26.3179C301.728 26.8841 302.737 27.8071 303.353 29.087C303.968 30.3669 304.276 32.1021 304.276 34.2927C304.276 36.3603 303.968 38.0463 303.353 39.3508C302.737 40.6307 301.728 41.5784 300.325 42.1937C298.922 42.809 297.051 43.1167 294.713 43.1167H290.209V48.8394ZM293.753 30.3053H290.209V38.2801H293.753C295.501 38.2801 296.67 37.9848 297.261 37.3941C297.851 36.8033 298.147 35.7696 298.147 34.2927C298.147 32.8898 297.851 31.8806 297.261 31.2653C296.67 30.6253 295.501 30.3053 293.753 30.3053ZM313.32 48.8394H307.413V25.4688H318.563C321.492 25.4688 323.621 26.1333 324.95 27.4625C326.304 28.767 326.981 30.6992 326.981 33.259C326.981 35.1788 326.501 36.8279 325.541 38.2063C324.581 39.56 323.313 40.4092 321.738 40.7538L321.701 40.8646C322.316 41.2584 322.993 41.9106 323.732 42.8213C324.47 43.732 325.196 44.7289 325.91 45.8119C326.648 46.8703 327.301 47.8671 327.867 48.8024V48.8394H321L317.012 42.9321C316.668 42.4152 316.385 42.046 316.163 41.8245C315.966 41.603 315.72 41.4676 315.425 41.4184C315.154 41.3691 314.711 41.3445 314.095 41.3445H313.32V48.8394ZM317.603 30.2684H313.32V36.5449H317.603C318.834 36.5449 319.683 36.2988 320.15 35.8065C320.643 35.3142 320.889 34.5143 320.889 33.4067C320.889 32.299 320.643 31.4991 320.15 31.0068C319.683 30.5146 318.834 30.2684 317.603 30.2684ZM330.471 37.1356C330.471 34.1574 330.803 31.7945 331.468 30.0469C332.157 28.2993 333.326 27.044 334.975 26.281C336.649 25.518 338.975 25.1365 341.953 25.1365C344.193 25.1365 346.051 25.3457 347.528 25.7641C349.005 26.1826 350.174 26.8594 351.035 27.7948C351.897 28.7301 352.5 29.9731 352.845 31.5237C353.214 33.0498 353.398 34.9204 353.398 37.1356C353.398 39.3754 353.214 41.2707 352.845 42.8213C352.5 44.3474 351.897 45.5781 351.035 46.5134C350.174 47.4487 349.005 48.1256 347.528 48.544C346.051 48.9624 344.193 49.1716 341.953 49.1716C339.713 49.1716 337.855 48.9624 336.378 48.544C334.901 48.1256 333.732 47.4487 332.871 46.5134C332.009 45.5781 331.394 44.3474 331.025 42.8213C330.655 41.2707 330.471 39.3754 330.471 37.1356ZM341.953 44.0028C343.528 44.0028 344.71 43.8059 345.497 43.4121C346.285 43.0183 346.814 42.3291 347.085 41.3445C347.356 40.3354 347.491 38.9324 347.491 37.1356C347.491 35.3634 347.356 33.9851 347.085 33.0005C346.814 32.016 346.285 31.3268 345.497 30.933C344.71 30.5146 343.528 30.3053 341.953 30.3053C340.402 30.3053 339.221 30.5146 338.409 30.933C337.621 31.3268 337.08 32.016 336.784 33.0005C336.513 33.9851 336.378 35.3634 336.378 37.1356C336.378 38.9324 336.513 40.3354 336.784 41.3445C337.08 42.3291 337.621 43.0183 338.409 43.4121C339.221 43.8059 340.402 44.0028 341.953 44.0028Z'
      fill='#354463'
    ></path>
  </svg>
);

// ─── Logo icon (symbol only — shown in collapsed sidebar) ────────────────────
const AppLogoIcon = () => (
  <svg
    width={26}
    height={26}
    viewBox='4 4 99 100'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M 4,4 L 72,54 L 4,104 L 21,104 L 59,54 L 21,4 Z' fill='#3D63DD' />
    <path
      d='M 103,4 L 35,54 L 103,104 L 86,104 L 48,54 L 86,4 Z'
      fill='#3D63DD'
    />
  </svg>
);

// ─── Shipment custom icon ─────────────────────────────────────────────────────
const ShipmentIcon = () => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{ fill: 'currentColor' }}
  >
    <path d='M6.33333 6.0625L8 5.22917L9.66667 6.0625V2.10417H6.33333V6.0625ZM3.83333 12.1042V10.4375H8V12.1042H3.83333ZM2.16667 15.4375C1.70833 15.4375 1.31583 15.2744 0.989167 14.9483C0.663055 14.6217 0.5 14.2292 0.5 13.7708V2.10417C0.5 1.64583 0.663055 1.25333 0.989167 0.926667C1.31583 0.600555 1.70833 0.4375 2.16667 0.4375H13.8333C14.2917 0.4375 14.6842 0.600555 15.0108 0.926667C15.3369 1.25333 15.5 1.64583 15.5 2.10417V13.7708C15.5 14.2292 15.3369 14.6217 15.0108 14.9483C14.6842 15.2744 14.2917 15.4375 13.8333 15.4375H2.16667ZM2.16667 13.7708H13.8333V2.10417H11.3333V8.77083L8 7.10417L4.66667 8.77083V2.10417H2.16667V13.7708Z' />
  </svg>
);

// ─── Navigation definition ────────────────────────────────────────────────────
const FULL_NAVIGATION = [
  {
    segment: 'quick-quote',
    title: 'Quick Quote',
    shortTitle: 'Quote',
    icon: <RequestQuoteRounded />
  },
  {
    segment: 'dashboard',
    title: 'Dashboard',
    shortTitle: 'Dashboard',
    icon: <DashboardOutlinedIcon />
  },
  {
    segment: 'carriers',
    title: 'Carriers',
    shortTitle: 'Carriers',
    icon: <LocalShippingOutlinedIcon />
  },
  {
    segment: 'users',
    title: 'Users',
    shortTitle: 'Users',
    icon: <GroupOutlinedIcon />
  },
  {
    segment: 'roles',
    title: 'Roles',
    shortTitle: 'Roles',
    icon: <LockPersonIcon />
  },
  {
    segment: 'manage-shipments',
    title: 'Shipment',
    shortTitle: 'Shipment',
    icon: <ShipmentIcon />
  },
  {
    segment: 'view-locations',
    title: 'Locations',
    shortTitle: 'Locations',
    icon: <LocationOnOutlinedIcon />
  },
  {
    segment: 'app-registration',
    title: 'App Registration',
    shortTitle: 'App Reg',
    icon: <AccountTreeOutlinedIcon />
  },
  { segment: 'Logs', title: 'Logs', shortTitle: 'Logs', icon: <WysiwygIcon /> },
  {
    segment: 'settings',
    title: 'Settings',
    shortTitle: 'Settings',
    icon: <SettingsIcon />
  },
  {
    segment: 'invoice-audit',
    title: 'Invoice Audit',
    shortTitle: 'Invoice',
    icon: <DescriptionOutlinedIcon />
  }
];

const PERMISSION_MAP = {
  'quick-quote': 'Quick',
  dashboard: 'Dashboard',
  carriers: 'Carriers',
  users: 'Users',
  roles: 'Roles',
  'manage-shipments': 'Manage-Shipments',
  'view-locations': 'Locations',
  'app-registration': 'App-Registration',
  'track-shipment': 'Track-Shipments',
  Logs: 'Logs',
  settings: 'Settings',
  'invoice-audit': 'Invoice-Audit'
};

// Alias paths so sub-routes keep the parent nav item highlighted
const SEGMENT_ALIASES = {
  'quick-quote': ['/bookshipment', '/bookshipmentTL', '/bookshipmentParcel'],
  carriers: ['/create-carrier'],
  'manage-shipments': [
    '/dispatchshipmentLTL',
    '/dispatchshipmentTL',
    '/dispatchshipmentParcel'
  ],
  'view-locations': ['/add-locations']
};

const isActive = (segment, pathname) => {
  if (pathname === '/' + segment) return true;
  const aliases = SEGMENT_ALIASES[segment];
  return aliases ? aliases.includes(pathname) : false;
};

// ─── Toolbar: notifications + user profile ────────────────────────────────────
const ToolbarActions = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const UserDetails = useSelector(state => state.user.UserDetailsObj.userInfo);
  const AgencyAdminDetails = useSelector(
    state => state.user.AgencyAdminDetails
  );
  const UserNotificationsObj = useSelector(
    state => state.user.UserAppNotifications
  );
  const rememberMe = useSelector(state => state.userDetails.rememberMe);

  const UserNotifications = UserNotificationsObj?.notifications || [];

  const [userProfileOpen, setUserProfileOpen] = useState(false);
  const [notifOpen, setNotifOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [notifView, setNotifView] = useState({});

  const firstLetter = UserDetails?.firstName
    ? UserDetails.firstName.charAt(0).toUpperCase()
    : '';
  const lastLetter = UserDetails?.lastName
    ? UserDetails.lastName.charAt(0).toUpperCase()
    : '';

  const avatarStyle = {
    objectFit: 'cover',
    borderRadius: '8px',
    height: '36px',
    width: '36px',
    backgroundColor: 'white',
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#133',
    cursor: 'pointer'
  };

  const handleLogout = () => {
    sessionStorage.setItem('FetchTrackingLoader', 'false');
    AagencyLogout().catch(() => {});
    localStorage.clear();
    !rememberMe && dispatch(setPasswordRedux(''));
    !rememberMe && dispatch(setEmailRedux(''));
    !rememberMe && dispatch(setUserDetailsObj({}));
    document.cookie =
      'userInfo=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    dispatch(setUserToken(''));
    dispatch(setLoginAgencyID(''));
    dispatch(setUserRolePermissionsArr([]));
    dispatch(setRateValues(''));
    dispatch(setQuickQuoteTLRateValues(''));
    dispatch(setQuickQuoteRateValues(''));
    dispatch(setQuickQuotePickUpCheckedRedux(false));
    dispatch(setQuickQuoteDeliveryCheckedRedux(false));
    dispatch(setClassWeight(''));
    dispatch(setDimensionsWeight(''));
    history.push('/agency-signin');
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <NotificationDialog
        notifView={notifView}
        isOpen={dialogOpen}
        handleClose={() => setDialogOpen(false)}
      />

      {/* Notifications */}
      <Dropdown
        isOpen={notifOpen}
        toggle={() => setNotifOpen(p => !p)}
        className='list-inline-item'
      >
        <DropdownToggle tag='a' id='notifficationdropdown' type='button'>
          <Badge badgeContent={UserNotificationsObj?.count} color='primary'>
            <NotificationsIcon
              sx={{ fontSize: 24, color: 'rgb(25, 118, 210)', mt: '2px' }}
            />
          </Badge>
        </DropdownToggle>
        <DropdownMenu
          end
          style={{
            width: 380,
            maxHeight: 500,
            overflowY: 'auto',
            padding: '12px 16px'
          }}
        >
          <div
            style={{
              marginBottom: 12,
              display: 'flex',
              justifyContent: 'space-between'
            }}
          >
            <Typography>
              Notifications ({UserNotificationsObj?.count || 0})
            </Typography>
          </div>
          {UserNotifications.length === 0 ? (
            <div style={{ padding: '24px 0', textAlign: 'center' }}>
              <Typography>No new notifications</Typography>
            </div>
          ) : (
            <div style={{ marginBottom: 12 }}>
              {UserNotifications.map(n => (
                <NotificationCard
                  key={n.id}
                  id={n.id}
                  title={n.title}
                  description={sanitizeHTML(n.message)}
                  time={formatNotificationTime(n.receivedOn)}
                  status={!n.isRead}
                  setGlobalOpen={setDialogOpen}
                  setGlobalNotification={setNotifView}
                />
              ))}
            </div>
          )}
          <div
            style={{
              borderTop: '1px solid #e9ecef',
              paddingTop: 12,
              marginTop: 4,
              display: 'flex',
              justifyContent: 'flex-end'
            }}
          >
            <Link
              to='/notifications'
              style={{
                fontSize: 13,
                textDecoration: 'underline',
                color: '#1976d2'
              }}
            >
              View All
            </Link>
          </div>
        </DropdownMenu>
      </Dropdown>

      {/* User profile */}
      <Dropdown
        isOpen={userProfileOpen}
        toggle={() => setUserProfileOpen(p => !p)}
        className='list-inline-item'
      >
        <DropdownToggle tag='a' id='userdropdown' type='button'>
          {AgencyAdminDetails?.userAvatar ? (
            <img
              src={base_logo_url + AgencyAdminDetails.userAvatar}
              alt='avatar'
              style={avatarStyle}
            />
          ) : (
            <img
              src={`data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36"><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle">${encodeURIComponent(
                firstLetter + lastLetter
              )}</text></svg>`}
              alt={UserDetails?.firstName}
              style={avatarStyle}
            />
          )}
        </DropdownToggle>
        <DropdownMenu end style={{ minWidth: 160 }}>
          <li>
            <Link className='dropdown-item' to='/user-profile'>
              My Profile
            </Link>
          </li>
          <li>
            <button
              className='dropdown-item'
              onClick={handleLogout}
              style={{
                background: 'none',
                border: 'none',
                width: '100%',
                textAlign: 'left',
                cursor: 'pointer'
              }}
            >
              Logout
            </button>
          </li>
        </DropdownMenu>
      </Dropdown>
    </Box>
  );
};

// ─── Sidebar + AppBar layout (replaces Toolpad Core) ─────────────────────────
const AppLayout = ({ children, navigation }) => {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [themeMode] = useState('light');
  const isMobile = useMediaQuery('(max-width:899px)');
  const [navTrackRef, setNavTrackRef] = useState('');
  const [trackDialogOpen, setTrackDialogOpen] = useState(false);
  const [trackDialogRef, setTrackDialogRef] = useState('');
  const [trackDialogKey, setTrackDialogKey] = useState(0);

  const handleNavTrack = () => {
    const ref = navTrackRef.trim();
    if (ref) {
      setTrackDialogRef(ref);
      setTrackDialogKey(k => k + 1);
      setTrackDialogOpen(true);
      setNavTrackRef('');
    }
  };

  const muiTheme = useMemo(
    () => createTheme({ palette: { mode: themeMode } }),
    [themeMode]
  );

  const pageTitle = useMemo(() => {
    const match = navigation.find(item =>
      isActive(item.segment, location.pathname)
    );
    return match ? match.title : '';
  }, [navigation, location.pathname]);

  const isDark = themeMode === 'dark';

  const renderNavItems = expanded =>
    navigation.map(item => {
      const active = isActive(item.segment, location.pathname);
      return (
        <ListItem
          key={item.segment}
          disablePadding
          sx={{ display: 'block', mb: '2px' }}
        >
          <ListItemButton
            component={Link}
            to={'/' + item.segment}
            onClick={() => isMobile && setMobileOpen(false)}
            sx={{
              minHeight: expanded ? 44 : 60,
              flexDirection: expanded ? 'row' : 'column',
              justifyContent: expanded ? 'initial' : 'center',
              alignItems: 'center',
              px: expanded ? 2 : 0.5,
              py: expanded ? 0 : 0.75,
              mx: '8px',
              borderRadius: '8px',
              bgcolor: active ? 'rgba(25,118,210,0.12)' : 'transparent',
              color: active ? 'primary.main' : 'text.secondary',
              '&:hover': {
                bgcolor: active ? 'rgba(25,118,210,0.18)' : 'action.hover'
              }
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: expanded ? 1.5 : 0,
                mb: expanded ? 0 : 0.25,
                justifyContent: 'center',
                color: active ? 'primary.main' : 'text.secondary'
              }}
            >
              {item.icon}
            </ListItemIcon>
            {expanded ? (
              <ListItemText
                primary={item.title}
                primaryTypographyProps={{
                  fontSize: '0.875rem',
                  fontWeight: active ? 600 : 400,
                  whiteSpace: 'nowrap',
                  color: active ? 'primary.main' : 'text.primary'
                }}
              />
            ) : (
              <Typography
                sx={{
                  fontSize: '0.6rem',
                  fontWeight: active ? 600 : 400,
                  color: active ? 'primary.main' : 'text.secondary',
                  textAlign: 'center',
                  lineHeight: 1.2,
                  width: COLLAPSED_WIDTH - 8
                }}
              >
                {item.shortTitle || item.title}
              </Typography>
            )}
          </ListItemButton>
        </ListItem>
      );
    });

  const navListSx = {
    pt: 1,
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': { display: 'none' },
    scrollbarWidth: 'none'
  };

  return (
    <ThemeProvider theme={muiTheme}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
          overflow: 'hidden',
          bgcolor: 'background.default'
        }}
      >
        {/* ── Full-width AppBar ── */}
        <AppBar
          position='static'
          elevation={0}
          sx={{
            zIndex: 100,
            bgcolor: isDark ? 'background.paper' : '#F7F8FA',
            borderBottom: '1px solid',
            borderColor: 'divider',
            color: 'text.primary',
            flexShrink: 0
          }}
        >
          <Toolbar sx={{ minHeight: '64px !important', px: 2 }}>
            {/* Desktop: sidebar collapse/expand toggle */}
            <IconButton
              onClick={() => setSidebarOpen(o => !o)}
              size='small'
              sx={{ display: { xs: 'none', md: 'flex' }, mr: 1, color: 'text.secondary' }}
            >
              {sidebarOpen ? <MenuOpenIcon /> : <MenuIcon />}
            </IconButton>
            {/* Mobile: open drawer */}
            <IconButton
              onClick={() => setMobileOpen(true)}
              sx={{ display: { md: 'none' }, mr: 1, color: 'text.primary' }}
            >
              <MenuIcon />
            </IconButton>
            <AppLogo />
            {pageTitle && (
              <>
                <Box sx={{ width: '1px', height: 24, bgcolor: 'rgba(0,0,0,0.22)', mx: 1.5, flexShrink: 0 }} />
                <Typography
                  sx={{
                    fontSize: { xs: 13, sm: 16 },
                    fontWeight: 600,
                    color: 'text.primary',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {pageTitle}
                </Typography>
              </>
            )}
            <Box sx={{ flexGrow: 1 }} />
            {/* Right: track search + notifications + user */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {location.pathname !== '/manage-shipments' && (
                <Box
                  sx={{
                    display: { xs: 'none', sm: 'flex' },
                    alignItems: 'center',
                    gap: 0.5
                  }}
                >
                  <TextField
                    size='small'
                    variant='outlined'
                    placeholder='Track shipment…'
                    value={navTrackRef}
                    onChange={e => setNavTrackRef(e.target.value)}
                    onKeyPress={e => e.key === 'Enter' && handleNavTrack()}
                    sx={{ width: { sm: 180, md: 330 } }}
                    InputProps={{
                      sx: {
                        height: 34,
                        fontSize: 13,
                        bgcolor: 'white',
                        '& fieldset': { borderColor: 'rgba(0,0,0,0.18)' }
                      }
                    }}
                  />
                  <Button
                    variant='contained'
                    size='small'
                    onClick={handleNavTrack}
                    sx={{
                      height: 34,
                      textTransform: 'none',
                      whiteSpace: 'nowrap',
                      fontSize: 13
                    }}
                  >
                    Track
                  </Button>
                </Box>
              )}
              <ToolbarActions />
            </Box>
          </Toolbar>
        </AppBar>

        {/* ── Sidebar + Content row ── */}
        <Box sx={{ display: 'flex', flex: 1, overflow: 'hidden', minHeight: 0 }}>
          {/* Sidebar */}
          <Box
            component='nav'
            sx={{
              width: { md: sidebarOpen ? DRAWER_WIDTH : COLLAPSED_WIDTH },
              flexShrink: { md: 0 },
              transition: 'width 0.22s ease'
            }}
          >
            {/* Mobile: temporary overlay */}
            <Drawer
              variant='temporary'
              open={mobileOpen}
              onClose={() => setMobileOpen(false)}
              ModalProps={{ keepMounted: true }}
              sx={{
                display: { xs: 'block', md: 'none' },
                '& .MuiDrawer-paper': {
                  width: DRAWER_WIDTH,
                  boxSizing: 'border-box',
                  bgcolor: 'background.paper',
                  borderRight: '1px solid',
                  borderColor: 'divider',
                  display: 'flex',
                  flexDirection: 'column'
                }
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  px: 2,
                  minHeight: 64,
                  borderBottom: '1px solid',
                  borderColor: 'divider',
                  flexShrink: 0
                }}
              >
                <AppLogo />
              </Box>
              <List sx={navListSx}>{renderNavItems(true)}</List>
            </Drawer>

            {/* Desktop: permanent */}
            <Drawer
              variant='permanent'
              open
              sx={{
                display: { xs: 'none', md: 'block' },
                '& .MuiDrawer-paper': {
                  width: sidebarOpen ? DRAWER_WIDTH : COLLAPSED_WIDTH,
                  overflowX: 'hidden',
                  transition: 'width 0.22s ease',
                  bgcolor: 'background.paper',
                  borderRight: '1px solid',
                  borderColor: 'divider',
                  boxSizing: 'border-box',
                  display: 'flex',
                  flexDirection: 'column',
                  top: '64px',
                  height: 'calc(100vh - 64px)'
                }
              }}
            >
              <List sx={navListSx}>{renderNavItems(sidebarOpen)}</List>
            </Drawer>
          </Box>

          {/* Content */}
          <Box
            sx={{
              flex: 1,
              overflow: 'auto',
              minWidth: 0,
              scrollbarWidth: 'none',
              '&::-webkit-scrollbar': { display: 'none' },
              bgcolor: isDark ? 'background.default' : '#F5F5F5'
            }}
          >
            {children}
          </Box>
        </Box>
      </Box>

      {/* Track Shipment dialog — opens from navbar search, no page navigation */}
      <Dialog
        open={trackDialogOpen}
        onClose={() => setTrackDialogOpen(false)}
        maxWidth='xl'
        fullWidth
        PaperProps={{ sx: { height: '85vh' } }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            py: 1.5,
            px: 2,
            borderBottom: '1px solid',
            borderColor: 'divider'
          }}
        >
          <Typography fontWeight={600}>
            Track Shipment — {trackDialogRef}
          </Typography>
          <IconButton size='small' onClick={() => setTrackDialogOpen(false)}>
            <CloseIcon fontSize='small' />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 1, overflow: 'auto' }}>
          <TrackShipmentModule
            key={trackDialogKey}
            searchRef={trackDialogRef}
          />
        </DialogContent>
      </Dialog>
    </ThemeProvider>
  );
};

// ─── Main Layout ──────────────────────────────────────────────────────────────
const Layout = props => {
  const location = useLocation();
  const history = useHistory();
  const CurrentRoute = location.pathname;
  const selectedModuleName = localStorage.getItem('selectedModulePersist');

  const dispatch = useDispatch();
  const rememberMe = useSelector(state => state.userDetails.rememberMe);
  const [userRolePermissionsArray, setUserRolePermissionsArray] =
    useState(null);

  const UserId = sessionStorage.getItem('UserAuthToken');
  const tokenExpiry = localStorage.getItem('tokenExpiryTime');
  const tokenExpiryTime = new Date(tokenExpiry);
  const currentTime = new Date();

  const userRolePermissions = useSelector(
    state => state.userDetails.userRolePermissionsArr
  );
  const [routesArray, setRoutesArray] = useState(null);
  const UserIsAdmin = useSelector(state => state.userDetails.isAdmin);

  // ── Build permission arrays ───────────────────────────────────────────────
  useEffect(() => {
    const updatedArray = new Set();
    const routes = new Set();
    userRolePermissions?.forEach(permission => {
      const allLevelsTrue =
        !permission.level1 &&
        !permission.level2 &&
        !permission.level3 &&
        !permission.level4 &&
        !permission.level5;
      const dashboardAllLevelsTrue =
        allLevelsTrue &&
        !permission.level6 &&
        !permission.level7 &&
        !permission.level8 &&
        !permission.level9 &&
        !permission.level10;

      if (!dashboardAllLevelsTrue) {
        updatedArray.add(permission.permissionName);
        if (permission.permissionName.includes('Dashboard'))
          routes.add('/dashboard');
      }
      if (!allLevelsTrue) {
        updatedArray.add(permission.permissionName);
        if (permission.permissionName.includes('Quick')) {
          routes.add('/quick-quote');
          routes.add('/bookshipment');
          routes.add('/bookshipmentTL');
        }
        if (permission.permissionName.includes('Carriers')) {
          routes.add('/carriers');
          routes.add('/create-carrier');
        }
        if (permission.permissionName.includes('Users')) routes.add('/users');
        if (permission.permissionName.includes('Roles')) routes.add('/roles');
        if (permission.permissionName === 'Manage-Shipments') {
          routes.add('/manage-shipments');
          routes.add('/dispatchshipmentLTL');
          routes.add('/bookshipmentTL');
          routes.add('/dispatchshipmentParcel');
          routes.add('/dispatchshipmentTL');
        }
        if (permission.permissionName.includes('Locations')) {
          routes.add('/view-locations');
          routes.add('/add-locations');
        }
        if (permission.permissionName.includes('Settings'))
          routes.add('/settings');
        if (permission.permissionName.includes('App-Registration'))
          routes.add('/app-registration');
        if (permission.permissionName.includes('Invoice-Audit'))
          routes.add('/invoice-audit');
        if (permission.permissionName === 'Track-Shipments')
          routes.add('/track-shipment');
        if (permission.permissionName.includes('Logs')) routes.add('/Logs');
        routes.add('/user-profile');
        routes.add('/notifications');
        routes.add('/user-dashboard');
        routes.add('/new-dashboard');
        routes.add('/claims-dashboard');
        routes.add('/');
      }
    });
    setUserRolePermissionsArray(Array.from(updatedArray));
    setRoutesArray(Array.from(routes));
  }, [userRolePermissions]);

  // ── Cookie / session guard ────────────────────────────────────────────────
  const handleResetLocalStorage = () => {
    !rememberMe && dispatch(setPasswordRedux(''));
    !rememberMe && dispatch(setEmailRedux(''));
    !rememberMe && dispatch(setUserDetailsObj({}));
    localStorage.clear();
    history.push('/agency-signin', 'sessionExpired');
  };

  useEffect(() => {
    const getCookieValue = name => {
      const cookies = document.cookie.split('; ');
      for (let i = 0; i < cookies.length; i++) {
        const c = cookies[i].split('=');
        if (c[0] === name) return c[1];
      }
      return null;
    };
    if (getCookieValue('userInfo') === null) handleResetLocalStorage();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Token expiry redirect ─────────────────────────────────────────────────
  setTimeout(() => {
    if (tokenExpiryTime - currentTime <= 0) {
      window.location.href = '/agency-signin';
      localStorage.clear();
      localStorage.setItem('CurrentRoute', CurrentRoute);
      !rememberMe && dispatch(setPasswordRedux(''));
      !rememberMe && dispatch(setEmailRedux(''));
      dispatch(setUserToken(''));
      dispatch(setLoginAgencyID(''));
      dispatch(setRateValues(''));
      dispatch(setQuickQuoteTLRateValues(''));
      dispatch(setQuickQuoteRateValues(''));
    }
  }, tokenExpiryTime - currentTime);

  // ── Idle timer ────────────────────────────────────────────────────────────
  useIdleTimer({
    onIdle: () => {
      if (UserId) {
        history.push('/agency-locked-screen', {
          currentRoute: CurrentRoute,
          selectedModuleName
        });
      }
    },
    onActive: () => {},
    onAction: () => {},
    timeout: 3600000,
    throttle: 500
  });

  // ── Route access guard ────────────────────────────────────────────────────
  useEffect(() => {
    if (!routesArray) return;
    const modulesURLs = [
      '/quick-quote',
      '/bookshipment',
      '/dispatchshipmentLTL',
      '/bookshipmentTL',
      '/dispatchshipmentTL',
      '/bookshipmentParcel',
      '/dispatchshipmentParcel',
      '/dashboard',
      '/user-dashboard',
      '/new-dashboard',
      '/claims-dashboard',
      '/carriers',
      '/create-carrier',
      '/users',
      '/roles',
      '/manage-shipments',
      '/view-locations',
      '/add-locations',
      '/app-registration',
      '/track-shipment',
      '/Logs',
      '/dispatch',
      '/settings',
      '/user-profile',
      '/not-assigned',
      '/invoice-audit',
      '/notifications',
      '/'
    ];
    const currentPath = location.pathname;
    if (!modulesURLs.includes(currentPath)) history.push('/404');
    if (routesArray && !UserIsAdmin && UserId) {
      if (currentPath === '/') {
        history.push(
          routesArray.includes('/manage-shipments')
            ? '/manage-shipments'
            : routesArray.includes('/quick-quote')
              ? '/quick-quote'
              : routesArray[0]
        );
      }
      if (
        modulesURLs.includes(currentPath) &&
        !routesArray.includes(currentPath)
      ) {
        localStorage.setItem('invalidUrl', currentPath);
        history.push('/not-assigned');
      }
    }
  }, [location.pathname, routesArray, UserIsAdmin, history]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Notifications polling ─────────────────────────────────────────────────
  const fetchAppNotifications = () => {
    GetAppNotifications(true, 5)
      .then(res =>
        dispatch(
          setUserAppNotifications({
            notifications: res?.data?.data,
            count: res?.data?.pagingInfo?.pageSize
          })
        )
      )
      .catch(() => {});
  };

  useEffect(() => {
    if (!UserId || UserId === '') return;
    fetchAppNotifications();
    const interval = setInterval(fetchAppNotifications, 300000);
    return () => clearInterval(interval);
  }, [UserId]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Permission-filtered navigation ───────────────────────────────────────
  const filteredNavigation = useMemo(() => {
    if (UserIsAdmin) return FULL_NAVIGATION;
    if (!userRolePermissionsArray) return [];
    return FULL_NAVIGATION.filter(item => {
      const key = PERMISSION_MAP[item.segment];
      return key && userRolePermissionsArray.some(p => p.includes(key));
    });
  }, [UserIsAdmin, userRolePermissionsArray]);

  return (
    <React.Fragment>
      {UserId && UserId !== '' ? (
        <AppLayout navigation={filteredNavigation}>{props.children}</AppLayout>
      ) : (
        <SignIn />
      )}
    </React.Fragment>
  );
};

export default Layout;
